module.exports = __webpack_public_path__ + "img/cartW.e8a568cb.png";